export default {
    homeArmstrong: {
        href: '/discover/updates',
    },
    discover: {
        href: '/network-home',
    },
    meV2: {
        href: '/you',
    },
};
//# sourceMappingURL=navigation.js.map